import type { PurchaseRequest, ReviveOffer } from "@newfungame/contracts";

export interface DefeatActions {
  /** «Прокачать и в бой» после проигрыша: покупки по порядку через API (I2). */
  upgrade(purchases: PurchaseRequest[]): void;
  /** Предложение реванша показано (аналитика). */
  reviveShown(offer: ReviveOffer): void;
}

const noop = () => {};

export const defaults: DefeatActions = {
  upgrade: noop,
  reviveShown: noop,
};

declare module "../actions" {
  interface WindowActions extends DefeatActions {}
}
